import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';

import { addToCart, addToWishlist, addToCompare } from '../../../actions'
import ProductListItem from "./categoryProductItem";
// import ProductListingLoader from '../../common/loading/productListing';


class ProductListing extends Component {

    render() {
        const { searchProducts,numOfProducts,products, addToCart, symbol, addToCompare, loading, addToWishlistClicked, presentURL } = this.props;
        // addToWishlist , error


        if (loading) {
            return (
                <div>
                    <div className="product-wrapper-grid">
                        <div className="container-fluid">
                        <div className="loading-cls"></div>
                        </div>
                    </div>
                </div>
                // <ProductListingLoader />
            )
        }
        return (
           
            <div>

                {  numOfProducts >= 0  ? 
                
                <div className="product-wrapper-grid">
                    <div className="container-fluid">
                        {searchProducts.length > 0 ?
                            <InfiniteScroll
                                dataLength={this.props.limit} //This is important field to render the next data
                                next={this.props.fetchMoreItems}
                                hasMore={this.props.hasMoreItems}
                                loader={<div className="loading-cls"></div>}
                                // loader={<ProductListingLoader />}
                                endMessage={
                                    <p className="seen-cls seen-it-cls">
                                         <b>End of list !</b>
                                    </p>
                                }
                            >
                                <div className="row">
                                    {searchProducts.slice(0, this.props.limit).map((product, index) =>
                                        <div className={`${this.props.colSize === 3 ? 'col-xl-3 col-md-6 col-grid-box' : 'col-lg-4'}`} key={index}>
                                            <ProductListItem product={product} symbol={symbol}
                                                onAddToCompareClicked={() => addToCompare(product)}
                                                onAddToWishlistClicked={() => addToWishlistClicked(product)}
                                                onAddToCartClicked={addToCart} key={index} 
                                                colSize = {this.props.colSize}
                                                presentURL={presentURL}
                                                />
                                                
                                        </div>)
                                    }
                                </div>
                            </InfiniteScroll>
                            :
                        <div className="row">
                            <div className="col-sm-12 text-center section-b-space mt-5 no-found" >
                                {/* <img src={`${process.env.PUBLIC_URL}/assets/images/empty-search.jpg`} className="img-fluid mb-4" /> */}
                                <h3>Sorry. Couldn't find the product you were looking For.</h3>
                                <Link to={`${process.env.PUBLIC_URL}/`} className="btn btn-solid">continue shopping</Link>
                            </div>
                        </div>
                        }
                    </div>
                </div> :   <div className="product-wrapper-grid">
                    <div className="container-fluid">
                        {products.length > 0 ?
                            <InfiniteScroll
                                dataLength={this.props.limit} //This is important field to render the next data
                                next={this.props.fetchMoreItems}
                                hasMore={this.props.hasMoreItems}
                                loader={<div className="loading-cls"></div>}
                                // loader={<ProductListingLoader />}
                                endMessage={
                                    <p className="seen-cls seen-it-cls">
                                         <b>End of list !</b>
                                    </p>
                                }
                            >
                                <div className="row">
                                    {products.slice(0, this.props.limit).map((product, index) =>
                                        <div className={`${this.props.colSize === 3 ? 'col-xl-3 col-md-6 col-grid-box' : 'col-lg-' + this.props.colSize}`} key={index}>
                                            <ProductListItem product={product} symbol={symbol}
                                                onAddToCompareClicked={() => addToCompare(product)}
                                                onAddToWishlistClicked={() => addToWishlistClicked(product)}
                                                onAddToCartClicked={addToCart} key={index} 
                                                presentURL={presentURL}
                                                />
                                                
                                        </div>)
                                    }
                                </div>
                            </InfiniteScroll>
                            :
                        <div className="row">
                            <div className="col-sm-12 text-center section-b-space mt-5 no-found" >
                                {/* <img src={`${process.env.PUBLIC_URL}/assets/images/empty-search.jpg`} className="img-fluid mb-4" /> */}
                                <h3>Sorry. Couldn't find the product you were looking For.</h3>
                                <Link to={`${process.env.PUBLIC_URL}/`} className="btn btn-solid">continue shopping</Link>
                            </div>
                        </div>
                        }
                    </div>
                </div>
    }
            </div>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    // products: getVisibleproducts(state.data, state.filters),
    symbol: state.data.symbol,
    products: state.category.products,
    loading: state.category.loading,
    error: state.category.error,
    numOfProducts : state.searchFilters.numOfProducts,
    searchProducts : state.searchFilters.products,
    presentURL: state.tenant.presentURL,
})

const mapDispatchToProps = dispatch => bindActionCreators({
    addToCart: addToCart,
    addToWishlist: addToWishlist,
    addToCompare: addToCompare,
}, dispatch)


export default connect(mapStateToProps, mapDispatchToProps)(ProductListing);